<div
  class="dropdown flex align-items-center justify-content-center"
  [ngClass]="[!!className ? className : '', isDisabled ? 'disabled' : '']"
  (mouseenter)="isDropDownOpen = true"
  (mouseleave)="isDropDownOpen = false"
  (keydown.enter)="toggleActiveWithKey($event)"
  (keydown.space)="toggleActiveWithKey($event)"
  tabindex="0"
>
  <div class="flex align-items-center justify-content-between dropdown__title c-pointer">
    @if (title) {
      <span class="truncate" [ngStyle]="styleOptions.menuHeadingStyles">{{ title }}</span>
    }
    <span class="pl-xxs dropdown__title__icon">
      <lib-down-arrow-icon [ngClass]="'icon-' + styleOptions.caretStyles.color" class="icon-xxxs"></lib-down-arrow-icon>
    </span>
  </div>
  @if (isDropDownOpen) {
    <div class="dropdown__content" [class.dropdown__content-right]="dropdownPosition === 'right'" role="menu">
      @for (item of list; track item; let i = $index) {
        <p
          class="dropdown__content__item flex justify-content-between"
          [class.dropdown__disabled]="item?.disabled"
          [class.dropdown__content__item--selected]="item.isSelected"
          [ngStyle]="$safeNavigationMigration(styleOptions?.menuItemStyles)"
          tabindex="0"
          (click)="onSelect(item, $event)"
          (keydown.enter)="onSelect(item, $event)"
          (keydown.space)="onSelect(item, $event)"
          (focus)="onFocus(i)"
          (blur)="onBlur(i)"
          role="menuitem"
          aria-disabled="{{ item?.disabled }}"
        >
          {{ item.title }}
          @if (isSelectedTickVisible && item.isSelected) {
            <span class="dropdown__content__icon-wrapper ml-xxs">
              <lib-fill-tick-round-icon
                class="icon-green icon-xxs flex"
                [attr.data-qa-id]="'green-tick-icon'"
              ></lib-fill-tick-round-icon>
            </span>
          }
        </p>
      }
    </div>
  }
</div>
